import boatRacingIcon from 'assets/images/eventBoatRacing/boatEventIcon.png'
import bunpimayIcon from 'assets/images/eventBunpimay/iconEvent.png'
import eventIcon from 'assets/images/eventWater/iconEvent.png'
import iconBoat from 'assets/images/eventBoatRacingT10/iconBoat.png'
import InviteModal from 'components/Modal/InviteModal'
import ModalWinnerEventBunpimay from 'components/Modal/ModalEvenBunpimay/ModalWinnerEventBunpimay'
import WinnerBoatRacing from 'components/Modal/PopupModal/WinnerBoatRacing'
import ServiceUserModal from 'components/Modal/ServiceUserModal'
import WinnerThingyan from 'components/Modal/WinnerThingyan'
import SnackbarComponent from 'components/SnackbarComponent'
import { PATHS } from 'config/routes'
import {
	getCheckEventBoatRacing102025Query,
	getCheckEventBoatRacingQuery,
	getCheckEventBunpimayQuery,
	getCheckEventWaterQuery,
	getEventBoatRacing102025Rank,
	useCheckSub,
} from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import { useContext, useEffect, useRef, useState } from 'react'
import { useQuery } from 'react-query'
import { useSelector } from 'react-redux'
import {
	Outlet,
	useLocation,
	useNavigate,
	useSearchParams,
} from 'react-router-dom'
import { curState } from 'store/selector'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { getUserinfo, setData } from 'utils/localStorage'
import { SocketContext } from 'utils/socket'
import Footer from './components/Footer'
import FooterMobile from './components/FooterMobile'
import Header from './components/Header'
import HeaderMobile from './components/HeaderMobile'
import ButtonEvent from 'pages/Event/EventBoatRacingT10/components/ButtonEvent'
import VictoryAnnouncement from 'pages/Event/EventBoatRacingT10/components/VictoryAnnouncement'
import NotificationModal from 'pages/Event/EventBoatRacingT10/components/NotificationModal'
import { useTranslation } from 'react-i18next'

function MainLayout() {
	const { t } = useTranslation()
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const selector = useSelector(curState)
	const userInfo = getUserinfo()
	const [searchParams] = useSearchParams()
	const codeParams = searchParams.get('code')
	const allowParams = searchParams.get('allow')
	const navigate = useNavigate()
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const isMobileLg = useMediaQuery(`(max-width: ${mediaQueryPoint.lg}px)`)
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const location = useLocation()
	const [openUserModal, setOpenUserModal] = useState(false)
	const [showVictoryPopup, setShowVictoryPopup] = useState(false);
	const [openModalWinLostT102025, setOpenModalWinLostT102025] = useState(false);
	const [dataCheckSub, setDataCheckSub] = useState()

	// useEffect(() => { //chạy lần đầu khi vào web chuyển đến event
	// 	if( userInfo && codeParams && allowParams === 'true' ){
	// 		return;
	// 	}
	// 	const fromHome = sessionStorage.getItem("fromHome");
	// 	if (fromHome) {
	// 		if (location.pathname === "/" && !fromHome) {
	// 			navigate("/event-boat-racing", { replace: true });
	// 		}
	// 		sessionStorage.removeItem("fromHome");
	// 	} else {
	// 		location.pathname === "/" && navigate("/event-boat-racing", { replace: true })
	// 	}
	// }, []);

	const handleSeeDetail = () => {
		navigate('/event-boat-racing', { state: "RANK" })
		setShowVictoryPopup(false)
	}

	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())

	const { data: eventWater, refetch: refetchEvent } = useQuery(
		getCheckEventWaterQuery(),
	)

	const { data: eventBoatRacing, refetch: refetchEventBoatRacing } = useQuery(
		getCheckEventBoatRacingQuery(),
	)

	const { data: eventBunpimay, refetch: refetchEventBunpimay } = useQuery(
		getCheckEventBunpimayQuery(),
	)

	const { data: eventBoatRacing102025, refetch: refetchEventBoatRacing102025 } = useQuery(
		getCheckEventBoatRacing102025Query(),
	)
	const {
		data: rankRacing102025,
		refetch: fetchEventBoatRacing102025Rank,
	} = useQuery(
		getEventBoatRacing102025Rank({
			my_rank: 1,
			limit: 1,
		}),
		{
			enabled: false,
			retry: false,
		}
	);

	useEffect(() => {
		// refetchEvent()
		// refetchEventBoatRacing()
		// refetchEventBunpimay()
		refetchEventBoatRacing102025()
	}, [user])


	useEffect(() => {
		const endDate = new Date(eventBoatRacing102025?.end_time_finish);
		const isFinished = eventBoatRacing102025?.is_finished === 1;
		const now = new Date();
		const isExpired = now > endDate;

		if (isFinished && isExpired) {
			fetchEventBoatRacing102025Rank();
		}
	}, [eventBoatRacing102025])

	useEffect(() => {
		if (
			location.pathname.indexOf(
				PATHS.PLAYROOM_PAGE.replace(':roomId/:gameId', ''),
			) === -1
		) {
			if (location.state && location.state.previous !== undefined) {
				if (
					location.state.previous.indexOf(
						PATHS.PLAYROOM_PAGE.replace(':roomId/:gameId', ''),
					) !== -1
				) {
					const dataRoom = location.state.previous.split('/')
					socket.emit('leave room', { room_id: dataRoom[dataRoom.length - 1] })
					window.history.replaceState({}, document.title)
				}
			} else setSocketRoomId(0)
			document.body.classList.remove('disable-scroll')
		}
	}, [location])

	useEffect(() => { }, [selector])

	const { showSnackbar } = selector

	useEffect(() => {
		if (userInfo?.isSub === false && eventBoatRacing102025?.is_show === 1) {
			const storagePackageKey = `isPopupShownPackage_T10-2025`;
			const alreadyShownPackage = localStorage.getItem(storagePackageKey);

			if (!alreadyShownPackage && eventBoatRacing102025?.is_show === 1) {
				localStorage.setItem(storagePackageKey, "true");
				userInfo?.isSub === false && setOpenModalWinLostT102025(true)
			}
		} else {
			const hasShown = localStorage.getItem('hasShownSubModal')
			if (!hasShown && user?.isSub === false) {
				setOpenUserModal(true)
				localStorage.setItem('hasShownSubModal', 'true')
			}
		}

	}, [user?.isSub, isLoadingUser, userInfo, eventBoatRacing102025?.is_show])

	const listPathRemoveIconEvent = [
		PATHS.EVENT_WATER_PAGE,
		PATHS.RESULT_EVENT_WATER_PAGE,
		PATHS.EVENT_BOAT_RACING_PAGE,
		PATHS.RESULT_EVENT_BOAT_RACING_PAGE,
		PATHS.BUNPIMAY_PAGE_HOME,
	]

	const { mutate: mutateCheckSub } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			// setDataCheckSub(data?.data)
		}
	})

	useEffect(() => {
		(location?.pathname === '/' && !!userInfo) && mutateCheckSub(
			allowParams == 'true' && codeParams
				? { location: "HOME", from: "auto" }
				: undefined
		)
	}, [location?.pathname, searchParams, user])

	useEffect(() => {
		setData('list-user-play', [])
	}, [location.pathname])

	const handleServiceUser = () => {
		window.location.href = userInfo?.urlWebView
	}

	useEffect(() => {
		const endDate = new Date(eventBoatRacing102025?.end_time_finish);
		const now = new Date();
		const isExpired = now > endDate;

		const isTopUser = userInfo?.userId === rankRacing102025?.ranks?.data[0]?.userId;

		const storageKey = `victoryPopupShown_T10-2025`;
		const alreadyShown = localStorage.getItem(storageKey);

		if (
			userInfo?.userId &&
			!alreadyShown &&
			isExpired &&
			isTopUser
		) {
			localStorage.setItem(storageKey, "true");
			setShowVictoryPopup(true);
		}
	}, [eventBoatRacing102025, userInfo, rankRacing102025]);

	return (
		<div className="main-layout-container">
			<div className="fly-water" id="show-water" />
			<div className="fly-boat-racing" id="show-boat-racing"></div>
			<div className="fly-water" id="show-item-fly" />
			{isMobile ? <HeaderMobile /> : <Header />}
			<div className="main-layout-outlet">
				{/* <span
					id="icon-event"
					onClick={() => {
						if (!eventWater?.is_finished) {
							navigate(PATHS.EVENT_WATER_PAGE)
						} else {
							navigate(PATHS.RESULT_EVENT_WATER_PAGE)
						}
					}}
					className={`main-layout-outlet_icon-event ${!eventWater?.is_show ||
						(isMobile &&
							listPathRemoveIconEvent.indexOf(location.pathname) !== -1)
						? 'none'
						: ''
						}`}
				>
					<img src={eventIcon} />
				</span> */}
				{/* <span
					id="icon-event-boat-racing"
					onClick={() => {
						if (!eventBoatRacing?.is_finished) {
							navigate(PATHS.EVENT_BOAT_RACING_PAGE)
						} else {
							navigate(PATHS.RESULT_EVENT_BOAT_RACING_PAGE)
						}
					}}
					className={`main-layout-outlet_icon-event ${!eventBoatRacing?.is_show ||
						(isMobileLg &&
							listPathRemoveIconEvent.indexOf(location.pathname) !== -1)
						? 'none'
						: ''
						}`}
				>
					<img srcSet={`${boatRacingIcon} 2x`} />
				</span> */}
				{/* <span
					id="icon-event-bunpimay"
					onClick={() => {
						if (!eventBunpimay?.is_finished) {
							navigate(PATHS.BUNPIMAY_PAGE_HOME)
						} else {
							navigate(PATHS.BUNPIMAY_PAGE_HOME, {
								state: {
									rank: 'rank',
								},
							})
						}
					}}
					className={`main-layout-outlet_icon-event ${!eventBunpimay?.is_show ||
						(isMobileLg && location.pathname.includes('/bunpimay'))
						? 'none'
						: ''
						}`}
				>
					<img srcSet={`${bunpimayIcon} 2x`} />
				</span> */}
				<Outlet />
			</div>
			<SnackbarComponent
				runSnackBar={showSnackbar.open}
				content={showSnackbar.content}
				severity={showSnackbar.severity}
			/>
			{/* {isMobile ? <FooterMobile /> : <Footer />} */}
			<InviteModal />
			{eventWater?.is_show && eventBoatRacing?.is_finished ? (
				<WinnerThingyan />
			) : null}
			{eventBoatRacing?.is_show && eventBoatRacing?.is_finished ? (
				<WinnerBoatRacing />
			) : null}
			{eventBunpimay?.is_show && eventBunpimay?.is_finished ? (
				<ModalWinnerEventBunpimay />
			) : null}

			<ServiceUserModal
				show={openUserModal}
				onHide={() => setOpenUserModal(false)}
				onClick={handleServiceUser}
			/>
			{eventBoatRacing102025?.is_show === 1 && <ButtonEvent />}
			<VictoryAnnouncement show={showVictoryPopup} handleCancel={() => setShowVictoryPopup(false)} handle={handleSeeDetail} />
			{/* show thắng chưa mua gói */}
			<NotificationModal
				show={openModalWinLostT102025}
				title={t('event.event_boa_racing_t10.notice')}
				content={t('event.event_boa_racing_t10.you_need_to_subscribe_to_the_dailysub_package_to_participate_in_the_boun_suang_heua_event_and_receive_many_valuable_rewards')}
				footer={
					<>
						<button onClick={() => {
							navigate('/event-boat-racing')
							setOpenModalWinLostT102025(false)
						}} className='button-event'>
							<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
							{t('event.event_boa_racing_t10.visit_event')}
						</button>
						<button onClick={() => {
							if (userInfo?.urlWebView) {
								window.location.href = userInfo?.urlWebView;
							}
						}}
							className='button-continue'>
							{t('event.event_boa_racing_t10.buy_package')}
						</button>
					</>}
				handleCancel={() => setOpenModalWinLostT102025(false)}
			/>
		</div>
	)
}

export default MainLayout
